<template>
  <div ref="rootRef">
    <template v-if="isVisible">
      <slot name="virtual-item" />
    </template>
    <div v-else :style="{ height: `${elHeight}px` }" class="virtual" />
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import createObserver from './observer';

const props = withDefaults(
  defineProps<{
    elementHeight?: number;
    virtualizeCount?: number;
  }>(),
  {
    elementHeight: 37,
    virtualizeCount: 40,
  },
);

const rootRef = ref<HTMLElement | null>(null);
const isVisible = ref(false);

const elHeight = computed(() => props.elementHeight * props.virtualizeCount);

const loadAndUnobserve = () => {
  isVisible.value = true;
  if (rootRef.value) {
    observer.unobserve(rootRef.value);
  }
};

const observer = createObserver(loadAndUnobserve);

onMounted(() => {
  if (rootRef.value) {
    observer.observe(rootRef.value);
  }
});

onBeforeUnmount(() => {
  observer.disconnect();
});
</script>

<style lang="scss" scoped>
</style>
